import React from "react";
import {Col, Row} from "react-bootstrap";
import {SvgIconComponent} from "@Components/Elements";


import "./index.scss";


type UserDashboardRefundCardComponentProps = {
    cardIcon: string;
    cardTitle: string;
    cardContent: string;
    cardDescription: string;
    cardType?: 'default' | 'special';
};


export const UserDashboardRefundCardComponent:React.FC<UserDashboardRefundCardComponentProps> = ({
    cardIcon, cardTitle, cardContent, cardDescription, cardType = 'default'
}) => {

    return (
        <Col xs={6} lg={'auto'} className={`user-dashboard-refund-card-component ${cardType}-card-type`}>
            <Row className={'user-dashboard-refund-card-component__content'}>
                <Col xs={12} className={`refund-card-header`}>
                    <SvgIconComponent iconSource={cardIcon} className={'refund-card-header-icon'} />
                    <span className={'refund-card-header-text'}>{cardTitle}</span>
                </Col>
                <Col xs={12} className={'refund-card-content'}>
                    <span>{cardContent}</span>
                </Col>
                <Col xs={12} className={'refund-card-description'}>
                    <span>{cardDescription}</span>
                </Col>
            </Row>
        </Col>
    );

};


export default UserDashboardRefundCardComponent;
